import devKeys from '@app/utils/keys/keys.development';
import prodKeys from '@app/utils/keys/keys.production';

const keys = typeof ENVIRONMENT !== 'undefined' && ENVIRONMENT === 'production' ? prodKeys : devKeys;

export default keys;
